import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'native-base';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';
import MessageExtensionBox from './MessageExtensionBox';
import { useAppNavigate } from '~/pages';
import { Button } from '~/shared/Theme';

import type { Stashboard, NormalizedExtension } from '@springbig/shared';
import { DarkSkeleton } from '~/shared/DarkSkeleton';

export const SliderLinkCard = ({ data }: { data: Stashboard }) => {

    const { bottomNav } = useAppSettings();
    const { navigate, params } = useAppNavigate();

    const { member, merchant } = useSpringBigStore();
    const [canNavigateToCart, setCanNavigateToCart] = useState<boolean>(false);
    const [canNavigateToShop, setCanNavigateToShop] = useState<boolean>(false);

    useEffect(() => {

        const canNavigateToCartTemp = bottomNav.find((value) => value?.toScreen === 'Cart');
        if (canNavigateToCartTemp && member?.merchant_website) {
            setCanNavigateToCart(true);
        }

        const canNavigateToShopTemp = bottomNav.find((value) => value?.toScreen === 'Shop');
        setCanNavigateToShop(canNavigateToShopTemp && merchant?.dutchie_plus_enabled);

    }, [bottomNav, merchant, member]);

    const sortExtensions = (stashboard: Stashboard) => {

        if (!stashboard) {
            return [];
        }

        const anyLinkExtensions = stashboard.any_link_extensions || [];
        const anyLinksNormalized = anyLinkExtensions.map((extension): NormalizedExtension => ({
            id: extension.id,
            thumbnail: extension.thumbnail?.url ?? null,
            title: extension.title,
            type: 'any_link',
            url: extension.url,
            wallet_type: null,
        }));

        const otherExtensions = stashboard.extensions?.filter(extension => extension.type !== 'any_link') || [];
        const otherExtensionsNormalized = otherExtensions.map((extension): NormalizedExtension => ({
            id: extension.id,
            thumbnail: extension?.reward_thumbnail ?? null,
            title: extension.title,
            type: extension.type,
            url: extension.url,
            wallet_type: extension.wallet_type ?? null,
        }));

        return [...anyLinksNormalized, ...otherExtensionsNormalized];
    };

    const extensions = sortExtensions(data);

    const navigateShopNow = () => {

        if (canNavigateToCart) {
            navigate(`w/${params.wallet_id}/cart`);
        }
        else if (canNavigateToShop) {
            navigate(`w/${params.wallet_id}/shop`);
        }
    };


    return (
        <>
            { extensions.length > 0 ? (
                <View
                    pt={4}
                    mx={extensions.length === 1 ? 'auto' : ''}
                >
                    <ScrollView
                        w={'100%'}
                        horizontal={true}
                        decelerationRate={0}
                        showsHorizontalScrollIndicator={true}
                    >
                        {extensions.map(extension => {

                            return (
                                <MessageExtensionBox
                                    key={`${extension.id}-${extension.type}`}
                                    stashboardKey={data._key}
                                    extension={extension}
                                />
                            );
                        })}
                    </ScrollView>
                </View>
            ) : (
                member?.merchant_website &&
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                    <Button
                        text={'messages.shop_now'}
                        onPress={navigateShopNow}
                    />
                </div>
            )}
        </>
    );
};
